import { render, staticRenderFns } from "./totalDetail.vue?vue&type=template&id=0a6a1157&scoped=true&"
import script from "./totalDetail.vue?vue&type=script&lang=js&"
export * from "./totalDetail.vue?vue&type=script&lang=js&"
import style0 from "./totalDetail.vue?vue&type=style&index=0&id=0a6a1157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a1157",
  null
  
)

export default component.exports